import React from "react";
import { connect } from "react-redux";
import moment from "moment";

moment().locale('es');

const mapState = (state) => {
	return {
		pagoPorKilometro: state.polizas.pagoPorKilometro,
		detallePagoPorKilometro: state.polizas.detallePagoPorKilometro
	};
};

const mapDispatch = (dispatch) => {
	return {

	};
};

class DetallePagoPorKilometro extends React.Component{	
	state = {
		fechaFin:"",
		kilometrosRecorridos: '0',
		porcentaje:'0',
		monto: '0'

	}

	componentWillReceiveProps(nextProps) {
		console.log("entra componentWillReceiveProps:"+nextProps.detallePagoPorKilometro.terminoPoliza);
		var date = moment(nextProps.detallePagoPorKilometro.terminoPoliza, 'DD/MM/YYYY').subtract(10, 'days').format('L');
		const porcentajeCupon = nextProps.detallePagoPorKilometro && nextProps.detallePagoPorKilometro.cupon ? nextProps.detallePagoPorKilometro.cupon.porcentaje : "";
		const monto = nextProps.detallePagoPorKilometro && nextProps.detallePagoPorKilometro.cupon ?nextProps.detallePagoPorKilometro.cupon.monto : "";

		this.setState({
			fechaFin: date,
			kilometrosRecorridos: nextProps.detallePagoPorKilometro.endKm - nextProps.detallePagoPorKilometro.startKm,
			porcentaje: porcentajeCupon,
			monto: monto,
		});
	}

	render(){

		return(
			<div className="popup-km">
				<div className="mt-34">
					<div className="modal-container">
						<h5 className="pd-lr-30">Distintivo bajo kilometraje
							<button type="button" className="close pull-right" data-dismiss="modal" aria-label="Close"><img src={ require("../img/x.svg") } alt="" /></button>
						</h5>
						<hr className="mt-34" />
						<div className="row"> 
							<div className="col-xs-12 col-md-10 col-md-offset-1">
								<h6 style={{color: '#183d7b', marginLeft: "-18px"}}>Registro de kilometraje inicial</h6>
								<div className="row">
									<table className="table table-striped table-center mt-34 tabla-recibos hidden-xs">
										<thead>
										<tr>
											<th className="text-center">Fecha de Captura</th>
											<th className="text-center"><span className="hide-mobile">Kilometraje Inicial</span><span className="show-mobile">Km Inicial</span></th>
										</tr>
										</thead>
										<tbody>
										<tr>
											<td className="text-center">{this.props.detallePagoPorKilometro.startDate == null ? '' : this.props.detallePagoPorKilometro.startDate.split(" ")[0]}</td>
											<td className="text-center">{this.props.detallePagoPorKilometro.startKm == null ? '' : this.props.detallePagoPorKilometro.startKm.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
										</tr>
										</tbody>
									</table>

									{
										this.props.detallePagoPorKilometro.isStartKmCaptured && !this.props.detallePagoPorKilometro.isEndKmCaptured 
										&&
										<table className="table table-striped table-center mt-34 tabla-recibos hidden-xs">
											<tbody>
												<tr>
													<td className=""><b>Registro de kilometraje final a partir de: </b>{this.state.fechaFin}</td>
												</tr>
											</tbody>
										</table>
									}

									<table className="table table-striped table-center mt-34 tabla-recibos tabla-images hidden-xs">
										<thead>
											<tr>
												<th className="text-center">Fotografías</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="">
													<div className="col-md-2 col-sm-3">{this.props.detallePagoPorKilometro.supIzq == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.supIzq}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.supIzq} /></a>}</div>
													<div className="col-md-2 col-sm-3">{this.props.detallePagoPorKilometro.supDer == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.supDer}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.supDer} /></a>}</div>
													<div className="col-md-2 col-sm-3">{this.props.detallePagoPorKilometro.infIzq == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.infIzq}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.infIzq} /></a>}</div>
													<div className="col-md-2 col-sm-3">{this.props.detallePagoPorKilometro.infDer == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.infDer}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.infDer} /></a>}</div>
													<div className="col-md-2 col-sm-3">{this.props.detallePagoPorKilometro.vin == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.vin}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.vin} /></a>}</div>
													<div className="col-md-2 col-sm-3">{this.props.detallePagoPorKilometro.startPhoto == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.startPhoto}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.startPhoto} /></a>}</div>
												</td>
											</tr>
										</tbody>
									</table>
									
									{
										this.props.detallePagoPorKilometro.isEndKmCaptured
										&&
										<div>
											<h6 style={{color: '#183d7b'}}>Registro de kilometraje final</h6>
											<table className="table table-striped table-center mt-34 tabla-recibos tabla-images hidden-xs">
												<thead>
													<tr>
														<th className="text-center">Fecha de Captura</th>
														<th className="text-center"><span className="hide-mobile">Kilometraje Final</span><span className="show-mobile">Km Final</span></th>
														<th className="text-center">Kiolómetros recorridos</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td className="text-center">{this.props.detallePagoPorKilometro.endDate == null ? '' : this.props.detallePagoPorKilometro.endDate.split(" ")[0]}</td>
														<td className="text-center">{this.props.detallePagoPorKilometro.endKm == null ? '' : this.props.detallePagoPorKilometro.endKm.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
														<td className="text-center" style={{fontWeight:'bold'}}>{this.state.kilometrosRecorridos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
													</tr>
												</tbody>
											</table>
											<table className="table table-striped table-center mt-34 tabla-recibos hidden-xs">
												<thead>
													<tr>
														<th>
															Fotografía
														</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															<div className="row">
																<div className="col-md-5 col-sm-6">
																	{this.props.detallePagoPorKilometro.endPhoto == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.endPhoto}>
																	<img className="img-responsive left-block" src={this.props.detallePagoPorKilometro.endPhoto} />
																	</a>}
																</div>
															</div>
														</td>
														<td className="text-center">
															<div className="row">
																<div className="col-xs-12 text-justify">
																	<p style={{fontSize:"14px"}}>
																		Obtuviste un cupón del <strong style={{fontWeight:'bold', color:'#183d7b'}}>{this.state.porcentaje}%</strong> de bonificación
																		para la renovación de tu Póliza que equivale a:
																	</p>
																	<p 
																	className="text-center"
																	style={{fontSize:"16px", fontWeight:"normal", color:"#183d7b"}}>
																		{this.state.monto.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} pesos
																	</p>
																	<p 
																	className="text-justify"
																	style={{fontSize:"14px", color:"#183d7b"}}>
																		Detalles en sección Beneficios Soy Cliente GNP
																		junto a la campana de notificaciones.
																	</p>
																</div>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									}									
								</div>
							</div>
							<div className="hidden-sm hidden-md hidden-lg ">
								<p className="text-center" style={{borderBottomColor:'1px solid rgb(255, 111, 32)', paddingTop: '4%', color: 'rgb(24, 61, 123)', fontWeight: 'bold'}}>Captura Inicial</p>
								<div className="row">
									<div className="col-xs-12 col-xs-offset2">
										<p className="text-center">
											{this.props.detallePagoPorKilometro.startKm == null ? '' : this.props.detallePagoPorKilometro.startKm.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
										</p>
										<p className="text-center">
											{this.props.detallePagoPorKilometro.startDate == null ? '' : this.props.detallePagoPorKilometro.startDate.split(" ")[0]}
										</p>
									</div>
									<div className="col-xs-12 col-xs-offset2"></div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detallePagoPorKilometro.supIzq == null ? '' : <a target="_blank" href={this.props.detallePagoPorKilometro.supIzq}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.supIzq} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detallePagoPorKilometro.supDer == null ? '' :<a target="_blank" href={this.props.detallePagoPorKilometro.supDer}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.supDer} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detallePagoPorKilometro.infIzq== null ? '' :<a target="_blank" href={this.props.detallePagoPorKilometro.infIzq}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.infIzq} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detallePagoPorKilometro.infDer == null ? '' :<a target="_blank" href={this.props.detallePagoPorKilometro.infDer}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.infDer} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detallePagoPorKilometro.vin == null ? '' :<a target="_blank" href={this.props.detallePagoPorKilometro.vin}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.vin} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detallePagoPorKilometro.startPhoto == null ? '' :<a target="_blank" href={this.props.detallePagoPorKilometro.startPhoto}><img className="img-responsive center-block" src={this.props.detallePagoPorKilometro.startPhoto} /></a>}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);

	}

}

export default connect(mapState, mapDispatch)(DetallePagoPorKilometro);


// WEBPACK FOOTER //
// ./src/home/detallePagoPorKilometro.cmpt.js